import { make } from "vuex-pathify"

const state = () => {
  return {
    errorMessage: null,
    successMessage: null,
  }
}

const actions = {
  error({ commit }, { title, message }) {
    commit("SET_ERROR_MESSAGE", { title, message })
  },
  clearErrorMessage({ commit }) {
    commit("SET_ERROR_MESSAGE", null)
  },
  success({ commit }, { title, message }) {
    commit("SET_SUCCESS_MESSAGE", { title, message })
  },
  clearSuccessMessage({ commit }) {
    commit("SET_SUCCESS_MESSAGE", null)
  },
}

const getters = {
  ...make.getters(state),
}

const mutations = {
  ...make.mutations(state),
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
